module.exports = __webpack_public_path__ + "img/jas-angelina_bern_ocular.d2ba33cb.jpg";